import { useEffect, useState } from "react"

import { RisebinarBanner, RisebinarSearchPage, RisebinarColumn } from "./components"
import { Category } from "@interfaces/category"
import Helmet from "@helpers/Helmet"
import { Header } from "@components/header"
import { FlexBox } from "@components/wrapper"
import { HariseninFooter } from "@components/harisenin"
import { DynamicHelmet } from "@interfaces/misc"
import { Risebinar } from "@interfaces/risebinar"

interface RisebinarListPageProps {
  categories: Category[]
  meta: DynamicHelmet
  initialData: Risebinar[]
}

function RisebinarListPage({ categories, meta, initialData }: RisebinarListPageProps) {
  const [isTransparent, setIsTransparent] = useState(true)

  function isBottom(el: HTMLElement) {
    const eleTop = el.getBoundingClientRect().top

    return eleTop < 60
  }

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("tagline") as HTMLElement
    const isBtm = isBottom(wrappedElement)

    if (isBtm) {
      setIsTransparent(false)
    } else {
      setIsTransparent(true)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", trackScrolling)
    return () => {
      window.removeEventListener("scroll", trackScrolling)
    }
  }, [])

  return (
    <>
      <Helmet
        isIndexed
        title={meta?.meta_title ?? "Event & Workshop"}
        description={
          meta?.meta_description ??
          "Harisenin.com adalah Online Education Platform yang menawarkan education-to-employment program untuk profesi yang paling banyak dibutuhkan saat ini"
        }
      />
      <Header transparent={isTransparent} isNotSticky />

      <FlexBox direction="col">
        <RisebinarBanner />
        <RisebinarSearchPage categories={categories} />
        <RisebinarColumn initialData={initialData} />
        <HariseninFooter />
      </FlexBox>
    </>
  )
}

export default RisebinarListPage
